export const FlagSV = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="swedish flag"
    >
      <path d="M16 0H0V14H16V0Z" fill="#006AA7" />
      <path d="M9 0H5V14H9V0Z" fill="#FECC00" />
      <path d="M16 5H0V9H16V5Z" fill="#FECC00" />
    </svg>
  );
};
